module.exports = __webpack_public_path__ + "a8d2ac5cfe6213c40ef23b36188d3d54.MP3";